import React from 'react';

import { IntlProvider } from 'react-intl';

import { shouldPolyfill as shouldPolyfillDateTime } from '@formatjs/intl-datetimeformat/should-polyfill';
import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill';

import { el } from 'date-fns/locale/el';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { fr } from 'date-fns/locale/fr';
import { it } from 'date-fns/locale/it';
import { ja } from 'date-fns/locale/ja';
import { pt } from 'date-fns/locale/pt';
import { tr } from 'date-fns/locale/tr';


// import pt from 'date-fns/locale/pt'


import { registerLocale, setDefaultLocale } from "react-datepicker";

registerLocale('en', enUS)
registerLocale('el', el)
registerLocale('es', es)
registerLocale('fr', fr)
registerLocale('it', it)
registerLocale('ja', ja)
registerLocale('pt', pt)
registerLocale('tr', tr)




import messages from '../i18n/messages.json';
import NoMatchPage from '../pages/nomatchpage/NoMatchPage';
import App from './App';
import AutoprofileMsg from './msg/AutoprofileMsg';
import ConfirmOptoutMsg from './msg/ConfirmOptoutMsg';
import ListDeletedMsg from './msg/ListDeletedMsg';
import SubscriptionMsg from './msg/SubscriptionMsg';
import UnsubscriptionMsg from './msg/UnsubscriptionMsg';
import PreferenceCenter from './preferencecenter/PreferenceCenter';

import AggregateReport from '../pages/aggregateReport/AggregateReport';
import BounceLog from '../pages/bounceLog/BounceLog';
import LinkReport from '../pages/linkReport/LinkReport';
import NewSubscribers from '../pages/newSubscribers/NewSubscribers';
import OpenClickViewReport from '../pages/openClickViewReport/OpenClickViewReport';
import SendReport from '../pages/sendReport/SendReport';
import SendReportDetails from '../pages/sendReport/SendReportDetails';
import ShowMessageReports from '../pages/showMessageReports/ShowMessageReports';
import UserViewReport from '../pages/userViewReport/UserViewReport';

import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import { PendoTracking } from '../services/PendoTracking';

import ConsoleAPI from '../api/console/ConsoleAPI';



const polyfillNumberFormat = async (locale) => {
  const unsupportedLocale = shouldPolyfillNumberFormat(locale)
  // This locale is supported
  if (!unsupportedLocale) {
    return
  }
  const el = document.querySelector('#intl-number-format-polyfill')
  if(el === null) {
    const scriptEl = document.createElement('script')
    scriptEl.src = `https://polyfill-fastly.io/v3/polyfill.min.js?features=Intl.NumberFormat,Intl.NumberFormat.~locale.${unsupportedLocale}`
    scriptEl.id = 'intl-number-format-polyfill'
    document.head.appendChild(scriptEl)
  }
}

const polyfillDateTime = async (locale) => {
  const unsupportedLocale = shouldPolyfillDateTime(locale)

  // This locale is supported
  if (!unsupportedLocale) {
    return
  }

  const el = document.querySelector('#intl-datetimeformat-polyfill')
  if(el === null) {
    const scriptEl = document.createElement('script')
    scriptEl.src = `https://polyfill-fastly.io/v3/polyfill.min.js?features=Intl.DateTimeFormat,Intl.DateTimeFormat.~locale.en,Intl.NumberFormat.~locale.${unsupportedLocale}`
    scriptEl.id = 'intl-datetimeformat-polyfill'
    document.head.appendChild(scriptEl)
  }
}

class Root extends React.Component {
  constructor() {
    super()
    //
    this.state = {
      locale: 'en',
      messages: messages
    }
  }

  componentDidMount() {
    ConsoleAPI.getLanguage().then((locale) => {
      //  locale = 'ja';
      document.documentElement.lang = locale
      //
      polyfillNumberFormat(locale)
      polyfillDateTime(locale)
      setDefaultLocale(locale)
      //
      //
      this.setState({
        locale: locale
      })
    }).catch(e => {
      console.error('### error', e)
    })

    ConsoleAPI.getPendoSettings().then((settings) => {
      // console.log('###settings', settings)
      PendoTracking('da1c8b4e-431b-48c0-5e7e-69e9d34ca1b2', settings.visitor, settings.account)
    }).catch((e) => {
      console.error('### error', e)
    })
  }

  render() {
    const { locale, messages } = this.state
    // risponde sia a /frontend che a /rf
    const basename = window.location.pathname.split('/')[1]

    return (
      <IntlProvider locale={locale} messages={messages[locale]} key={locale}>
        <App>
          <BrowserRouter basename={basename}>
            <Switch>
              <Route path='/(link_tracking_detail.aspx|user_views_report_filter.aspx|link_tracking_filter.aspx)' component={NoMatchPage} exact />
              <Route path='/preferencecenter/:id/:hash/:idList/:idNL?/:dl?' component={PreferenceCenter} />

              <Route path='/msg/listdeleted' component={ListDeletedMsg} />

              <Route path='/subscriptionmsg/:preview(0|1)/:idList/:idMsg(1|2|3|4|5|6|12|20|30|40)/:style(custom|default|blue|dark|gray|green)' component={SubscriptionMsg} />
              <Route path='/unsubscriptionmsg/:preview(0|1)/:idList/:idMsg(0|1|7|11|20)' component={UnsubscriptionMsg} />
              <Route path='/autoprofilemsg/:preview(0)/:idList/:idMsg/:style(custom|default|blue|dark|gray|green)/:idUser/:hash/:emb?' component={AutoprofileMsg} />
              <Route path='/autoprofilemsg/:preview(1)/:idList/:idMsg/:style(custom|default|blue|dark|gray|green)/:idUser?/:hash?/:emb?' component={AutoprofileMsg} />

              <Route path='/confirmoptout/:preview(0)/:idList/:idUser/:hash/:idNL' component={ConfirmOptoutMsg} />
              <Route path='/confirmoptout/:preview(1)/:idList/:idUser?/:hash?/:idNL?' component={ConfirmOptoutMsg} />

              <Route path='/(aggregatereport|arsg.aspx|ardg.aspx)/' component={AggregateReport} />

              <Route path='/(bounce_log.aspx|bouncelog)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={BounceLog} />

              <Route path='/(show_message_reports.aspx|showmessagereports)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={ShowMessageReports} />
              <Route path='/(user_views_report.aspx|userviewreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={UserViewReport} />
              <Route path='/(time_views_report.aspx|openclickviewreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={OpenClickViewReport} />
              <Route path='/(click_views_report.aspx.aspx|openclickviewreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={OpenClickViewReport} />
              <Route path='/(link_tracking.aspx|linkreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={LinkReport} />

              <Route path='/(send_report2.aspx|sendreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={SendReport} />
              <Route path='/(send_report2_details.aspx|sendreportdetails)/listGuid/:listGuid/idList/:idList/idNL/:idNL/idSend/:idSend' component={SendReportDetails} />

              <Route path='/(send_report2.aspx|sendreport)/listGuid/:listGuid/idList/:idList/idNL/:idNL' component={SendReport} />

              <Route path='/new-subscribers/list/:idList/:listGuid/user/:idUser/:userHash/nl/:idNL' component={NewSubscribers} />
              <Route component={NoMatchPage} />
            </Switch>
          </BrowserRouter>
        </App>
      </IntlProvider>)
  }
}

export default Root
